import React, { useState, useEffect } from "react";
import { Typography, Table, Collapse, Card, Tooltip, Tag, Button} from "antd";
import { RightOutlined } from "@ant-design/icons";
import { typeOption } from "../../../../../utils/Helpers";
import Pageloader from "../../../../../components/loader";
import moment from "moment";
import * as orderManagementActions from "../../../../../redux/actions/orderManagement.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CheckCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;
const { Panel } = Collapse;

const OrderIssueRequests = (props) => {
  const pagename = "Order Issue Requests";
  const [postData, setPostData] = useState(null);
  const [loading, setLoading] = useState(false);

  const postLists = async () => {
    try {
      setLoading(true);
      const pageData = {
        ...props.storeIdsFilter,
        currentPage: 1,
        limit: 10,
      };
      const {data} = await props.orderManagementActions.issuesRequestsAction(props.pageorderid, pageData);
      setPostData(data);
    } catch (e) { 
    } finally {
      setLoading(false);
    }
  };

  const paginationChange = async (page, limit) => {
    const pageData = {
      ...props.storeIdsFilter,
      currentPage: page,
      limit: limit,
    };
    try {
      setLoading(true);
      const {data} = await props.orderManagementActions.issuesRequestsAction(props.pageorderid, pageData);
      setPostData(data);
    } catch (e) { } finally {
      setLoading(false);
    }
  };

  const postColumns = [
    {
      title: 'Issue id',
      dataIndex: 'display_id',
      render: (value) => ( value || "-" )
    },
    // {
    //   title: 'Task Type',
    //   dataIndex: 'task_type',
    //   render: (value) => ( value || "-" )
    // },
    {
      title: 'Issue Created At',
      dataIndex: 'createdAt',
      render: (value) => {
        return value ?
        <><span>{moment(value).format("DD MMMM, yyyy")}</span>
        <p>{moment(value).format("h:mm A")}</p></>:"-"
      }
    },
    {
      title: 'Issue',
      dataIndex: 'type',
      render: (value) => (<><Text style={{textTransform: 'capitalize', marginRight: "5px"}}>{value.replace(/_/g, ' ')}</Text>
        {value === typeOption[0]?.value && <Tooltip title={<>
          Order not Packed<br/>
          No packtime<br/>
          (Now - Order creation time) <RightOutlined /> 10 mins<br/>
          Success: when order is Packed<br/>
        </>}><InfoCircleOutlined /></Tooltip>}
        {value === typeOption[1]?.value && <Tooltip title={<>
          Order not accepted<br/>
          Has packtime<br/>
          Free rider is <RightOutlined /> 0<br/>
          not accepted by any rider<br/>
          pending (now - order packed time)  since 5 mins (customizable)<br/>
          Success: when order is accepted<br/>
        </>}><InfoCircleOutlined /></Tooltip>}
        {value === typeOption[2]?.value && <Tooltip title={<>
          Order not Picked up<br/>
          Has packtime<br/>
          Accepted by rider = true<br/>
          rider reach mart = true<br/>
          Pick successful up by rider = false<br/>
          Pending (Now - Rider reach at mart time) <RightOutlined /> 5 mins<br/>
          Success: when order is picked up<br/>
        </>}><InfoCircleOutlined /></Tooltip>}
        {value.type === typeOption[3]?.value && <Tooltip title={<>
          Order has PACKED TIME<br/>
          Invoice amount less than order amount<br/>
          Success:<br/>
          when dispatch note contains<br/>
          Partial - Customer NR Order Cancelled Auto Partial<br/>
          Partial - Customer Not Agree for Partial Delivery<br/>
          Partial - Customer Agree for Partial Delivery<br/>
          Partial - Customer NR Proceed with Partial Invoice<br/>
          Or order status is cancelled or delivered<br/>
        </>}><InfoCircleOutlined /></Tooltip>}
        {value.type === typeOption[4]?.value && <Tooltip title={<>
          Order is created by new customer (has N icon in Overview page)<br/>
          Order creation time - now (time) > 45 mints<br/>
          Order status is NOT Dropoff Successful/Canceled<br/>
          Success:<br/>
          When order status is Delivered/Canceled<br/>
        </>}><InfoCircleOutlined /></Tooltip>}
      </> || "-" )
    },
    {
      title: 'Courier',
      dataIndex: 'rider',
      render: (value) => {
        return <>
          <div className="table-inner">
            {value ? <a onClick={()=>window.open(`rider/${value?.id}`)} >{`${value.display_id} - ${value.fullName}`}</a>:"-"}
            <span>{value?.phoneNumber || "-"}</span>
          </div>
        </>;
      },
    },
    {
      title: 'Order ID',
      dataIndex: 'order_id',
      render: (value) => ( value || "-")
    },
    {
      title: 'Zone',
      dataIndex: 'zone',
      render: (value) => ( value?.zoneName || "-" )
    },
    
    // {
    //   title: 'Deadline',
    //   dataIndex: 'deadline',
    //   render: (value) => {
    //     return value ?
    //     <><span>{moment(value).format("DD MMMM, yyyy")}</span>
    //     <p>{moment(value).format("h:mm A")}</p></>:"-"
    //   }
    // },
    {
      title: 'Issue Closed Time',
      dataIndex: 'completeAt',
      render: (value) => {
        return value ?
        <><span>{moment(value).format("DD MMMM, yyyy")}</span>
        <p>{moment(value).format("h:mm A")}</p></>:"-"
      }
    },
    {
      title: 'Open for',
      render: (value) => {
        var ms = moment(moment().format("DD/MM/YYY HH:mm:ss"),"DD/MM/YYYY HH:mm:ss").diff(moment(moment(value?.createdAt).format("DD/MM/YYY HH:mm:ss"),"DD/MM/YYYY HH:mm:ss"));
        var d = moment.duration(ms);
        return d && value?.status !== 'complete' ?
          <Text>
            <span>{d._data.days === 0?"":d._data.days+"Day"}</span>
            <p>{d._data.hours === 0 ? "" : `${('0'+d._data.hours).slice(-2)}hr`} {`${('0'+d._data.minutes).slice(-2)}mints`}</p>
          </Text>
        : <Tag icon={<CheckCircleOutlined />} color="success">Completed</Tag>
      },
    },
    {
      title: 'Picked by',
      dataIndex: 'rs_user',
      render: (value) => {
        return value ? value?.name: "-"
      }
    },
    {
      title: 'Order Delay',
      render: (value) => {
        let time = null;
        if(value?.orderId?.createdAt) { 
          let now = moment();
          let end = moment(value?.orderId?.createdAt);
          time = moment.duration(now.diff(end)).asMinutes();
        } 
        return value?.status !== 'complete' && (time ? <Text>
          <span>{Math.floor(time/24/60) === 0?"":Math.floor(time/24/60)+"Day"}</span>
          <p>{('0'+Math.floor(time/60%24)).slice(-2) + ':' + ('0'+Math.floor(time%60)).slice(-2)}</p>
        </Text>: "-")
      },
    },
    
  ];

  return (
    <Card title={pagename} bordered>
      <Collapse onChange={postData===null?postLists:()=>{}}>
        <Panel header={pagename}>
          {loading ? (<Pageloader />) : (
            <Table
              dataSource={postData && postData.data}
              columns={postColumns}
              pagination={{
                total: postData && postData.pagination.totalCount,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                pageSize:  postData && postData.pagination.limit,
                defaultCurrent:  postData && postData.pagination.currentPage,
                pageSizeOptions: ["10", "20", "30", "40", "50"],
                showSizeChanger: true,
                onChange: (currentPage, pageSize) => {
                  paginationChange(currentPage, pageSize);
                },
              }}
              />
          )}
        </Panel>
      </Collapse>
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    taskDetailData: state.OrderManagementReducer.taskDetailData,
    emailUser: state.authReducer.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    orderManagementActions: bindActionCreators(orderManagementActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderIssueRequests);

